export class ContractTemplate {
    id = null;

    description = '';

    allowLinkedWorkOrders = null;

    allowSelfDispatch = false;

    enableNonFlaggingTimesheets = false;

    active = true;

    workOrderTypeId = null;

    workOrderTypeDescription = '';

    contractScheduleTypeId = 1;

    contractScheduleTypeDescription = '';

    chargeTypes = [];

    compliances = [];

    createdById = '';

    createdByName = '';

    createdOn = null;

    modifiedById = '';

    modifiedByName = '';

    modifiedOn = null;
}
